var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueEditor',{staticClass:"fm-editor-container",attrs:{"id":_vm.id,"useCustomImageHandler":true,"disabled":_vm.disabled},on:{"image-added":_vm.handleImageAdded},model:{value:(_vm.dataModel),callback:function ($$v) {_vm.dataModel=$$v},expression:"dataModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }